import {
  AfterViewInit,
  Component,
  ComponentRef,
  createEnvironmentInjector,
  ElementRef,
  EnvironmentInjector,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Output,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { ImageWidgetComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/image-widget/image-widget.component';
import {
  ActiveConfig,
  CommonPageConfig,
  ComponentLabel,
  ContainerType,
  PopupSettings,
  PopupSettingType,
  SupportedDevice,
  SystemConfiguration,
  UiPagePageConfiguration,
  WidgetNames,
  WorkflowConfig,
  WorkflowPageConfig,
  WorkflowWidgetConfig,
  WorkflowZoneDevicesConfig,
} from '@finxone-platform/shared/sys-config-types';
import { combineLatest, map, Observable, of, Subject, takeUntil } from 'rxjs';
import { ActiveConfigService } from '../../../libs/services/active-config/active-config.service';
import { SystemConfigService } from '../../../libs/services/system-config/system-config.service';
import { WorkflowConfigService } from '../../../libs/services/workflow-config/workflow-config.service';
import { createMockEnvironmentProviders } from '../../../libs/utils/mock-environment.provider';

import { ActivatedRoute, ParamMap } from '@angular/router';

import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ParentContainerComponent } from '@app/finxone-web-frontend/app/Modules/zones/parent-container/parent-container.component';
import { AutoDestroy } from '@finxone-platform/shared/base-types';

import { ScrollViewportService } from '@app/finxone-web-frontend/app/Modules/layouts/footer-navbar/footer-navbar.component';
import { PageAsModalComponent } from '@app/finxone-web-frontend/app/Modules/zones/modal-container/modal/page-as-modal.component';
import { getAnyComponentByLabel } from '@app/finxone-web-frontend/app/lib/utils/get-component.utils';
import { setTokenListToLocalStorage } from '@app/finxone-web-frontend/app/lib/utils/utils';
import { ImagePopupSettingConfig } from '@app/finxone-web-frontend/app/lib/utils/widget.utils';
import { formatNameAsUrl } from '@app/finxone-web-frontend/app/lib/utils/zone-url.utils';
import { removeSpaceFromRole } from '@finxone-platform/shared/workflow-mapping';
import { Actions, ofActionDispatched, Select, Store } from '@ngxs/store';
import { DeviceType } from 'ngx-device-detector';
import {
  ClearContainerAndConfig,
  DroppedWidgetAction,
  WidgetTreeDroppedAction,
} from '../../../libs/actions/app-grid.action';
import { CardBackgroundImageAction, CardFlipIconAction } from '../../../libs/actions/card-background.action';
import {
  PageBackgroundImageAction,
  UpdatePageConfigurationAction,
} from '../../../libs/actions/page-background-workflow.action';
import { ProgressBarImageAction } from '../../../libs/actions/progress-bar-widget-workflow.action';
import { AppBuilderAdapterService } from '../../../libs/services/app-builder/app-builder-adapter.service';
import { RouteService } from '../../../libs/services/route-service/route.service';
import { AppGridState } from '../../../libs/state/app-grid.state';
import { ProjectsState } from '../../../libs/state/project.state';
import { StateService } from '@app/finxone-web-frontend/app/lib/services/state-service/state.service';
import { ApiService } from '../../../libs/services/api-service/api.service';

export const screenTypes = {
  [DeviceType.Mobile]: {
    dimension: '375 x 812',
    device: 'iPhone 14 Pro',
    deviceClass: 'device-iphone-14-pro',
    width: 375,
    height: 812,
  },
  [DeviceType.Desktop]: {
    dimension: '1920 x 1080',
    device: '1920 x 1080 Desktop',
    deviceClass: 'w-100',
    width: 1920,
    height: 1080,
  },
  [DeviceType.Tablet]: {
    dimension: '506 x 724',
    device: 'iPad Pro',
    deviceClass: 'device-ipad-pro',
    width: 506,
    height: 724,
  },
};

@Component({
  standalone: false,
  selector: 'app-device-holder',
  templateUrl: './device-holder.component.html',
  styleUrls: ['./device-holder.component.scss'],
})
export class DeviceHolderComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('viewport') viewport!: CdkVirtualScrollViewport;

  @Input() device: SupportedDevice = 'mobile';

  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @ViewChild('element', { static: true, read: ElementRef })
  element: ElementRef<HTMLElement>;
  // add type annotation to ViewChild decorator
  @ViewChild('container', { read: ViewContainerRef, static: true })
  container!: ViewContainerRef;
  containerComponent: ComponentLabel;
  @Output() showImagePopup = new EventEmitter<ImagePopupSettingConfig>();
  // add type annotations to class properties
  newEnvInjector: EnvironmentInjector;
  prevZone = '';
  currentItemPosition = 0;
  currentModuleType = '';
  currentSection = '';
  componentsList: any[] = [];
  workflowConfig!: WorkflowConfig;
  activeConfig!: ActiveConfig;
  droppedComponents: WorkflowPageConfig[] = [];
  activeIndex = 0;
  widgets!: WorkflowWidgetConfig[];
  parentComponentRef!: ComponentRef<any>;
  currentZone: any;
  showImageUploadPopup = false;
  popupSettings: PopupSettings = {
    show: false,
    type: PopupSettingType.IMAGE_WIDGET,
  };
  deviceClass = '';
  contentZoom = '100%';
  isFullSectionPage = false;

  prevParentComponentName: string | null = null;

  @Select(AppGridState.getVisibleCanvasComponent)
  visibleCanvasComponent!: Observable<{
    component: ComponentLabel;
    zone?: string;
    pageIndexOrSectionName?: number | string;
  }>;

  @Select(AppGridState.getDraggedWidgetConfig)
  draggedWidgetConfig$: Observable<WorkflowWidgetConfig | null>;

  draggedWidgetConfig: WorkflowWidgetConfig | null;

  currentPageConfig: UiPagePageConfiguration;
  public systemConfig: SystemConfiguration;
  public footerLayoutEnabled = false;

  onScroll(): void {
    const element = this.viewport.elementRef.nativeElement;
    this.scrollService.updateScrollPosition(element.scrollTop, element.clientHeight);
  }

  constructor(
    private systemConfigService: SystemConfigService,
    private injector: EnvironmentInjector,
    private appBuilderService: AppBuilderAdapterService,
    private workflowConfigService: WorkflowConfigService,
    private activeConfigService: ActiveConfigService,
    private store: Store,
    private actions$: Actions,
    private registry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private routeService: RouteService,
    private stateService: StateService,
    private apiService: ApiService,
    private scrollService: ScrollViewportService,
  ) {
    this.newEnvInjector = createEnvironmentInjector(
      createMockEnvironmentProviders(
        this.systemConfigService,
        this.store,
        this.registry,
        this.domSanitizer,
        this.routeService,
        this.activeConfigService,
        this.apiService,
        this.stateService,
      ),
      this.injector,
    );

    // Opens image popup for new config when a widget is dropped if required
    this.actions$.pipe(ofActionDispatched(DroppedWidgetAction, WidgetTreeDroppedAction)).subscribe(() => {
      if (this.draggedWidgetConfig) {
        if (this.draggedWidgetConfig.name == WidgetNames.IMAGE_WIDGET) {
          this.setPopupSettings(getAnyComponentByLabel(this.draggedWidgetConfig.name));
        }
        if (this.draggedWidgetConfig.name === WidgetNames.ADD_TO_GOOGLE_PAY_BUTTON) {
          setTokenListToLocalStorage();
        }
      }
    });

    this.actions$.pipe(ofActionDispatched(ProgressBarImageAction)).subscribe((data) => {
      const component = {} as Type<object>;
      this.setPopupSettings(component, data.widgetName);
    });

    this.actions$.pipe(ofActionDispatched(PageBackgroundImageAction)).subscribe(() => {
      const component = {} as Type<object>;
      this.setPopupSettings(component, 'page_background');
    });

    this.actions$.pipe(ofActionDispatched(CardBackgroundImageAction)).subscribe((data) => {
      const component = {} as Type<object>;
      this.setPopupSettings(component, WidgetNames.CARD, data.nestedConfigKey);
    });

    this.actions$.pipe(ofActionDispatched(CardFlipIconAction)).subscribe(() => {
      const component = {} as Type<object>;
      this.setPopupSettings(component, WidgetNames.CARD);
    });

    this.draggedWidgetConfig$.subscribe((widgetConfig) => (this.draggedWidgetConfig = widgetConfig));
  }

  ngOnChanges(): void {
    this.activeConfigService.updateTabSelection();
  }

  ngOnInit() {
    combineLatest([this.activeConfigService.getConfig(), this.systemConfigService.getConfig()]).subscribe(
      ([config, systemConfig]) => {
        this.systemConfig = systemConfig;
        this.activeConfig = config;
        this.currentZone = config.activeZone;
        this.activeIndex = config.activePageIndex;
        this.isFullSectionPage = config.isFullSectionPage;
        this.currentSection = config.activeSection;

        if (this.containerComponent && this.container) {
          const newPageConfig = this.getPageConfig(systemConfig, this.activeConfig);
          // If page config has changed
          if (
            newPageConfig &&
            JSON.stringify(this.currentPageConfig ?? {}) !== JSON.stringify(newPageConfig)
          ) {
            this.currentPageConfig = newPageConfig;
            this.container.clear();
            this.onSetParentComponent();
          }
        }
      },
    );

    this.actions$
      .pipe(ofActionDispatched(ClearContainerAndConfig), takeUntil(this.destroy$))
      .subscribe(() => {
        this.container.clear();
        this.droppedComponents = [];
      });

    this.actions$
      .pipe(ofActionDispatched(UpdatePageConfigurationAction), takeUntil(this.destroy$))
      .subscribe(() => {
        this.systemConfigService
          .getConfig()
          .pipe(
            takeUntil(this.destroy$),
            map((systemConfig) => {
              this.systemConfig = systemConfig;
              this.onSetParentComponent(); // TODO need to change the place after
            }),
          )
          .subscribe();
      });

    //Load active components on page refresh
    this.refreshWorkflowConfig();

    this.visibleCanvasComponent
      .pipe(takeUntil(this.destroy$))
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .subscribe(({ component }) => {
        this.containerComponent = component;
        const parentComponentChanged = this.prevParentComponentName !== component;

        const moduleChanged = this.prevZone != this.currentZone || this.container.length == 0;

        const allwidgets: WorkflowWidgetConfig[] = this.appBuilderService.getCurrentPageWidgets();
        this.widgets = allwidgets;
        if (moduleChanged || parentComponentChanged) {
          this.createParentComponent(component);
        }
        this.prevZone = this.currentZone;
        this.prevParentComponentName = component;
      });

    this.onGetLayoutPositionUpdates();
  }

  private onSetParentComponent() {
    this.activeConfigService.updateConfig((activeState) => {
      if (this.isContainerTypeAsModal) {
        const pageConfiguration = this.getPageConfig(
          this.systemConfig,
          this.activeConfig,
        ) as CommonPageConfig;
        this.activeIndex = this.getPageIndex(
          this.systemConfig,
          this.activeConfig,
          pageConfiguration?.url ?? '',
        );
        this.activeConfig.activePageIndex = activeState.activePageIndex = this.activeIndex;
      }
      this.loadFooterLayoutSetting(this.systemConfig, this.activeConfig);
      activeState.activeContainerType = this.isContainerTypeAsModal
        ? ContainerType.MODAL
        : ContainerType.PAGE;
      activeState.footerLayoutEnabled = this.footerLayoutEnabled;
      return activeState;
    });
    if (this.containerComponent) this.createParentComponent(this.containerComponent);
  }

  private loadFooterLayoutSetting(systemConfig: SystemConfiguration, activeConfig: ActiveConfig) {
    if (!systemConfig || !activeConfig) return;
    const pageConfig =
      systemConfig.ui.zones[activeConfig.activeZone]?.roles[formatNameAsUrl(activeConfig.activeRole)]?.[
        this.activeConfig.activeCanvasSubscription
      ]?.[this.activeConfig.activeDevice]?.pages[activeConfig.activePageIndex];
    if (pageConfig?.footerLayoutEnabled !== undefined) {
      this.footerLayoutEnabled = pageConfig.footerLayoutEnabled;
    }
  }

  private getPageConfig(
    systemConfig: SystemConfiguration,
    activeConfig: ActiveConfig,
  ): UiPagePageConfiguration | undefined {
    return systemConfig.ui.zones[activeConfig.activeZone].roles[
      formatNameAsUrl(this.activeConfig.activeRole)
    ]?.[this.activeConfig.activeCanvasSubscription]?.[this.activeConfig.activeDevice]?.pages[
      this.activeConfig.activePageIndex
    ]?.pageConfiguration;
  }

  private getContainerType(systemConfig: SystemConfiguration, activeConfig: ActiveConfig) {
    return systemConfig.ui.zones[activeConfig.activeZone].roles[
      formatNameAsUrl(this.activeConfig.activeRole)
    ][this.activeConfig.activeCanvasSubscription][this.activeConfig.activeDevice].pages[
      this.activeConfig.activePageIndex
    ]?.containerType;
  }

  private getPageIndex(systemConfig: SystemConfiguration, activeConfig: ActiveConfig, pageUrl: string) {
    let pageIndex = 0;
    const config =
      systemConfig.ui.zones[activeConfig.activeZone]?.roles[removeSpaceFromRole(activeConfig.activeRole)]?.[
        activeConfig.activeCanvasSubscription
      ][activeConfig.activeDevice];
    pageIndex = config?.pages?.findIndex((page) => page.url === pageUrl);
    return pageIndex;
  }

  private getZoneAndPageUrl(): ParamMap {
    this.refreshWorkflowConfig();
    const role = this.workflowConfig.permissionSections.roles.find(
      (role) => role.name === this.activeConfig.activeRole,
    );

    if (role) {
      const config = (
        role.zones[this.activeConfig.activeZone]?.canvases.subscription[
          this.activeConfig.activeCanvasSubscription
        ] as WorkflowZoneDevicesConfig
      )[this.activeConfig.activeDevice];

      if (config) {
        const pageConfigUrl = config.pages[this.activeConfig.activePageIndex]?.pageConfiguration?.url ?? '';
        const modalParam = this.isContainerTypeAsModal
          ? new Map<string, string>([
              ['modal-page', pageConfigUrl],
              ['page', pageConfigUrl],
            ])
          : new Map<string, string>([['page', pageConfigUrl]]);

        return new Map<string, string>([
          ['zone', formatNameAsUrl(this.activeConfig.activeZone)],
          ...modalParam,
        ]) as unknown as ParamMap;
      }
    }
    throw new Error('zone and page is invalid and not present');
  }

  private onGetLayoutPositionUpdates(): void {
    const page = this.parentComponentRef?.instance;
    if (page) page.envInjector = this.newEnvInjector;
  }

  createParentComponent(componentName: string): void {
    this.container.clear();
    this.widgets = [];
    // if container type is modal then display only modal component
    if (this.isContainerTypeAsModal) {
      this.loadModalComponent();
    } else {
      // if container type is page then display only parent component
      this.parentComponentRef = this.container.createComponent(
        this.getComponentBasedOnMainComponentPageName(componentName),
        {
          injector: Injector.create({
            providers: [
              {
                provide: ActivatedRoute,
                useValue: {
                  paramMap: of(this.getZoneAndPageUrl()),
                },
              },
            ],
          }),
          environmentInjector: this.newEnvInjector,
          index: this.widgets.length,
        },
      );
      if (componentName === 'ParentContainerComponent') {
        this.parentComponentRef.setInput('device', this.device);
        this.parentComponentRef.setInput('paymentProviderConfig', {
          payment: this.activeProject.paymentGateway,
          sandboxMode: this.activeProject?.sandboxMode,
        });
      }
    }
  }

  private get isContainerTypeAsModal() {
    return this.getContainerType(this.systemConfig, this.activeConfig) === ContainerType.MODAL;
  }

  private loadModalComponent(): void {
    const modalComponentRef = this.container.createComponent(PageAsModalComponent, {
      injector: Injector.create({
        providers: [
          {
            provide: ActivatedRoute,
            useValue: {
              paramMap: of(this.getZoneAndPageUrl()),
            },
          },
        ],
      }),
      environmentInjector: this.newEnvInjector,
      index: this.widgets.length,
    });

    modalComponentRef.setInput('device', this.device);
    modalComponentRef.setInput('paymentProviderConfig', {
      payment: this.activeProject.paymentGateway,
      sandboxMode: this.activeProject?.sandboxMode,
    });
  }

  private get activeProject() {
    return this.store.selectSnapshot(ProjectsState.getActiveProject);
  }

  setPopupSettings(
    mainActionSectionUpdate: Type<object>,
    widgetName?: WidgetNames | 'page_background',
    data?: string,
  ) {
    let popupSettings: PopupSettings = {
      show: true,
      type: widgetName ?? (mainActionSectionUpdate === ImageWidgetComponent ? WidgetNames.IMAGE_WIDGET : ''),
    };
    if (data) {
      popupSettings = { ...popupSettings, data: data };
    }
    this.showImagePopup.emit(popupSettings);
  }

  ngAfterViewInit(): void {
    this.onGetSelectedDevice(screenTypes[this.device]);
  }

  refreshWorkflowConfig() {
    this.workflowConfig = this.workflowConfigService.getLatestConfig();
  }

  onGetSelectedDevice(event: { width: number; height: number; deviceClass: string }) {
    this.activeConfigService.updateConfig((activeState) => {
      activeState.activeScreenWidth = event.width;
      activeState.activeScreenHeight = event.height;
      return activeState;
    });
    this.deviceClass = event.deviceClass;
  }

  private getComponentBasedOnMainComponentPageName(mainComponentPageName: string): Type<any> {
    switch (mainComponentPageName) {
      case 'IndividualAccountPageComponent':
        return ParentContainerComponent;
      case 'ParentContainerComponent':
        return ParentContainerComponent;
      case 'ChartWidgetIntegrationComponent':
        return ParentContainerComponent;
      case 'GenralAccountPageComponent':
        return ParentContainerComponent;
      case 'MenuComponent':
        return ParentContainerComponent;
      case 'CardManagementZonePageComponent':
        return ParentContainerComponent;
      default:
        throw new Error(
          `Invalid mainComponentPageName provided no components in getComponentBasedOnMainComponentPageName() match: ${mainComponentPageName}`,
        );
    }
  }
}
